export const FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'orderId',
    inputAdornment: '',
    label: 'N° de orden de compra',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 8 , 9 u 11 dígitos',
  },
];
